import { DateString } from '@fourthwall/components';
import { getDateFormat, SUMMARY_ROW_ID } from '@fourthwall/module-analytics';
import React from 'react';
export const createChartStatsTableColumnsMembersChange = (params) => [
    {
        header: params.precision === 'HOUR' ? 'Time' : 'Day',
        render: (item) => {
            if (item.id === SUMMARY_ROW_ID)
                return item.day;
            return React.createElement(DateString, { date: item.day, format: getDateFormat(params.precision), utc: true });
        },
    },
    {
        header: 'Change',
        render: (item) => React.createElement("span", null, (item.change <= 0 ? '' : '+') + item.change),
    },
];
